import { BUSINESSES_ROUTES } from '../../constants/_routes'
import businessesTypes from '../../constants/businessesTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'

const create_business_request = () => {
  return {
    type: businessesTypes.create.request
  }
}

const create_business_success = (response) => {
  return {
    type: businessesTypes.create.success,
    payload: response.data.business
  }
}

const create_business_failure = (messages) => {
  return {
    type: businessesTypes.create.failure,
    payload: messages
  }
}

const create_business = (values) => {
  return function (dispatch) {
    // Before Request
    dispatch(create_business_request())

    // Request
    axios.post(
      BUSINESSES_ROUTES.create,
      values
    ).then( response => {
      // success
      window.showSnackbar('success', "A new business has been created")
      dispatch( create_business_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error creating business."]
      }
      // dispatch( try_force_logoff(error.response) )
      window.showSnackbar('error', errors)
      dispatch( create_business_failure(errors))
    })
  }

}

export {
  create_business
}



// WEBPACK FOOTER //
// ./src/js/actions/businesses/create.js